import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { ColorLabel } from 'swag-client-common/components/ui/color-label';
import React from 'react';
import classnames from 'classnames';
import classes from './color-label-with-tooltip.scss';
export function ColorLabelWithTooltip({
  name,
  value,
  colorLabelBlockClassname,
  colorLabelClassname,
  colorLabelTextClassname,
  tooltipClassname,
  style,
  onClick,
  hideTooltip = false
}) {
  const Color = /*#__PURE__*/React.createElement(ColorLabel, {
    colorValue: value,
    colorName: name,
    labelClassName: classnames(classes.colorLabelText, colorLabelTextClassname),
    className: classnames(classes.colorLabel, colorLabelClassname),
    style: style,
    onClick: onClick
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.colorLabelBlock, colorLabelBlockClassname)
  }, hideTooltip && Color, !hideTooltip && /*#__PURE__*/React.createElement(Tooltip, {
    className: tooltipClassname,
    title: name,
    arrow: true
  }, Color));
}